<template>
  <div>
    <div class="right-box">
      <div class="right-title">
        <span>热门公司</span>
        <a
          href="http://www.100ec.cn/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E9%9B%B6%E5%94%AE&category=%E7%9B%B4%E6%92%AD%E7%94%B5%E5%95%86"
          target="_blank"
          >更多</a
        >
      </div>

      <Company />
    </div>

    <!-- <div class="right-box">
      <div class="right-title">
        <span>网经社法律消保台</span>
        <a href="http://www.100ec.cn/rulelaw/#/broadcast" target="_blank"
          >更多</a
        >
      </div>
      <div style="width: 300px">
        <a href="http://www.100ec.cn/rulelaw/#/broadcast" target="_blank">
          <img
            style="width: 100%"
            src="/Public/home/images/zyttk/flxb550.jpg"
          />
        </a>
      </div>
    </div> -->

    <!-- <div class="right-box">
      <div class="right-title">
        <span>网经社物流科技台</span>
        <a href="http://www.100ec.cn/logistics/#/broadcast" target="_blank"
          >更多</a
        >
      </div>
      <div style="width: 300px">
        <a href="http://www.100ec.cn/logistics/#/broadcast" target="_blank">
          <img style="width: 100%" src="/Public/home/images/wlkj550.jpg" />
        </a>
      </div>
    </div> -->

    <Email />
    <div style="width: 365px">
      <a href="https://www.100ec.cn/zt/wswjsxfpgyl/" target="_blank"> 
        <!-- <a href="https://www.100ec.cn/zt/wswjsxfpgyl/" target="_blank">  -->
        <!-- <img style="width: 100%" src="/Public/home/images/zyttk/xfpjr1.jpg" /> -->
        <img style="width: 100%" src="//imgs-b2b.toocle.com/Public/home/images/cpfw-2025-7-10/zbdshb13-2.jpg?v=1.1" />
      </a>
    </div>
    <!-- <div style="width: 365px; margin-top: 20px">
      <a>
        <img
          style="width: 100%"
          src="/Public/home/images/zyttk/zytgg/zbdst.jpg"
        />
      </a>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "ContentR",
  data() {
    return {
      params: {
        field: "数字零售",
        tabs: ["直播电商"],
      },
    };
  },
  created() {
    this.$store.commit("getCompanyTabs", this.params);
  },
};
</script>